/* eslint-disable react/jsx-filename-extension */
import React from 'react';

import Button from 'elements/Button';

export default function BrandIcon() {
  return (
    <Button
      className=""
      type="link"
      href="/"
    >
      <p className="text-white text-4xl">
        Vexa
        <span className="active-link">Tech</span>
      </p>
    </Button>
  );
}
